import Vue from "vue";

function removeDuplicateConnector(url) {
    let rawUrl = url;

    if (rawUrl.indexOf('&amp;') > 0) {
        const raw = rawUrl.replace('&amp;', '&');
        rawUrl = removeDuplicateConnector(raw);
    }

    return rawUrl;
}

Vue.component("modifications-party", {
    props: ["model", "invoked"],
    data() {
        return {
            loading: false,
            parties: [],
            isOpen: null,
            viewModel: this.model,
            partyId: null,
            loadedDocument: null,
            showPdfModal: false,
            documentSymbol: '',
            documentSymbolLink: '',
            useInLinePdfViewer: false,
            message: window.messages.modificationPartyDateRangeMessage,
            messageType: 'is-success'
        };
    },
    watch: {
        viewModel: function (vModel) {
            const self = this;

            if (vModel != self.model) {
                self.$emit('update:model', vModel);
            }
        },
        invoked: function (value) {
            const self = this;

            if (value) {
                self.initialize();
            }
            else {
                self.parties = [];
            }
        }
    },
    methods: {
        initialize() {
            const self = this;

            self.loading = true;
            self.$services.modification.searchPartyByDateRange({
                searchParameterDateFrom: self.model.searchParameterDateFrom,
                searchParameterDateTo: self.model.searchParameterDateTo,
                language: window.currentLanguage
            }).then((response) => {
                self.searchtriggered = false;

                if (response.status == 200) {
                    self.parties = response.data.parties;
                    self.viewModel.errors = {};
                    self.message = window.messages.modificationPartyNoResultMessage;
                    self.messageType = 'is-info';
                }
                else {
                    self.viewModel.invocableSearch = false;
                    self.viewModel.errors = response.errors;
                }
                self.loading = false;
            });
        },
        downloadDocument(documentSymbol) {
            const self = this;

            if (self.useInLinePdfViewer) {
                self.documentSymbol = documentSymbol;

                const symbolLink = `/api/modifications/downloadDocument?documentSymbol=${encodeURIComponent(documentSymbol)}`;
                self.documentSymbolLink = symbolLink;

                self.showPdfModal = true;
            }
            else {
                const raw = self.viewModel.letDocumentRedirectUrl;
                if (raw != null || raw != undefined) {
                    const replacer = encodeURIComponent('"' + documentSymbol + '"') + '+OR+' + encodeURIComponent('"' + documentSymbol + '/*"');
                    let upperCaseLanguage = 'ENGLISH';
                    switch (window.currentLanguage) {
                        case 1:
                        default:
                            upperCaseLanguage = 'ENGLISH';
                            break;
                        case 2:
                            upperCaseLanguage = 'FRENCH';
                            break;
                        case 3:
                            upperCaseLanguage = 'SPANISH';
                            break;
                    }


                    let url = raw.replace('{0}', replacer);
                    url = url.replace('{1}', upperCaseLanguage);

                    let final = removeDuplicateConnector(url);

                    console.log(final);

                    window.open(final, '_blank');
                }
            }
        }
    },
    template: `
        <div>
            <template v-if="loading"><loading></loading></template>
            <template v-else>
                <div v-if="parties != null && parties.length > 0">
                    <b-collapse
				        class="modification-card mb-2"
				        animation="slide"
				        v-for="(party, index) of parties"
				        :key="'party-' + party.id"
				        :open="isOpen == party.id"
				        @@open="isOpen = party.id">
                        <template #trigger="props">
                            <div class="modification-card-header" role="button">
					            <div class="modification-card-header-title">
                                    <span v-html="party.name"></span> 
					            </div>
                                <div class="modificaiton-card-header-document-symbol" v-for="(symbol, index) in party.documentSymbols" :key="index">
                                    <a  href="javascript:void(0)" @click="downloadDocument(symbol)" class="document-symbol">{{symbol}}</a>
                                </div>
				            </div>                                             
			            </template>                    
                        <div class="modification-card-content">
				            <div class="modification-content">
                                <modifications-annex :key="'partyAnnex-' + party.id" :startdate="viewModel.searchParameterDateFrom" :enddate="viewModel.searchParameterDateTo" :partyId="party.id" :annexes="party.annexes"></modifications-annex>
                            </div>
                        </div>
                    </b-collapse>
                </div>
                <b-message :type="messageType" v-else>
                    {{message}}                    
                </b-message>
            </template>    
            <b-modal id="pdfModal" min-width="900px" :width="1000" scroll="keep" ref="pdfModal" v-model="showPdfModal" #default="props" :can-cancel="['x']">
			    <div class="modal-card" style="width: auto">
				    <header class="modal-card-head">
					    <p class="modal-card-title">{{ documentSymbol }}</p>
				    </header>
				    <section class="modal-card-body">                        
                        <object :data="documentSymbolLink" type="application/pdf" width="100%" style="height: calc(100vh);">
                            <embed :src="documentSymbolLink">
                                <p>This browser does not support PDFs. Please download the PDF to view it: <a :href="documentSymbolLink">Download PDF</a>.</p>
                            </embed>
                        </object>
				    </section>					
                </div>
		    </b-modal>
        </div>        
	`
});

